// extracted by mini-css-extract-plugin
export default {"container":"nkbqgMu67tn67QEvVnfa","logo":"rZQr0NYoHZ01Gx1PAy3W"};